const code_product_info = $('.product-tabs-pc').html();
const code_product_meta = $('.product-meta-pc').html();

$(document).ready(function () {
  $('.footer-parent').click(function () {
      $(this).toggleClass('is-active');
      if ($(this).find('.footer-list').height() > 0)
          $($(this).find('.footer-list')).css("height", 0);
      else
          $($(this).find('.footer-list')).css("height", $(this).find('.footer-list').prop('scrollHeight'));
  })

  if($( window ).width() <= 999){
    $( ".product-tabs-pc" ).html('');
    $( ".product-tabs-sp" ).html('');
    $( ".product-tabs-sp" ).append( code_product_info );
  }

  if($( window ).width() <= 999){
    $( ".product-meta-pc" ).html('');
    $( ".product-meta-sp" ).html('');
    $( ".product-meta-sp" ).append( code_product_meta );
  }

  var countCart = document.querySelector(".header__cart-count").innerHTML;
  if(countCart > 0){
    document.querySelector(".header__cart-count").classList.add('is-show');
  }
});

$(window).scroll(function () {
    if ($(window).scrollTop() > $('.announcement-bar').height())
      $('.header').addClass('is-fixed');
    else
      $('.header').removeClass('is-fixed');
});


$( window ).resize(function() {
  if($( window ).width() > 999){
    $( ".product-tabs-pc" ).html('');
    $( ".product-tabs-sp" ).html('');
    $( ".product-tabs-pc" ).append( code_product_info );

    $( ".product-meta-pc" ).html('');
    $( ".product-meta-sp" ).html('');
    $( ".product-meta-pc" ).append( code_product_meta );
  }
  else{
    $( ".product-tabs-pc" ).html('');
    $( ".product-tabs-sp" ).html('');
    $( ".product-tabs-sp" ).append( code_product_info );

    $( ".product-meta-pc" ).html('');
    $( ".product-meta-sp" ).html('');
    $( ".product-meta-sp" ).append( code_product_meta );
  }
});